import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { AuthProvider } from '@/features/auth/AuthContext';
import { PeriodProvider } from '@/app/PeriodSwitcher';
import { ApiError } from '@/lib/api';
import { router } from '@/app/router';
import '@/styles/tokens.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Sinyal lapangan sering buruk — coba ulang beberapa kali, tapi jangan
      // sia-sia mengulang galat autentikasi/otorisasi.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PeriodProvider>
          <RouterProvider router={router} />
        </PeriodProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
